<template>
    <div>
        <div class="row justify-content-center">
          <div class="col-md-7" 
           :style="`background-image:url('${$store.state.data.undangan.gambar4}')`"
          style="background:#100001;position:relative;
          background-size:cover;background-repeat:no-repeat;background-position: center center;">
            <!-- <img src="@/static/draw1.jpeg" style="height:130vh;width:100%;position:absolute;right:0;top:0;z-index:10;" alt=""> -->
            <div v-if="particle" style="height:100%;width:100%;position:absolute;z-index:10000;" id="particlesjs3" ></div>
            <br>
            <br>
            <br>
            <br><br>
            <br>
            <div style="" 
              class="d-flex justify-content-center align-items-center shadow-lg rounded-lg">
              <br>
                  <div style="width:100%" class=" ">
                      <!-- <div class="row justify-content-center">
                        <div class="col-10 text-center" 
                        >
                           <curve-text :width="250" :height="80" :r="60" offset="50%" textid="my-curve-text"
                            style="margin-bottom:-40px;font-size:21px;letter-spacing:2px;font-family: 'Kaisei HarunoUmi', serif;display:block;margin:auto;"
                            class="font-semibold text-center"
                            >SAVE THE DATE</curve-text>
                            <div class="" style="position:relative;margin-top:-35px;width:100%;">
                             <p class=" text-4xl  text-center wow" style="letter-spacing: 2px;word-spacing: 2px;font-family: 'Alex Brush', cursive;"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                             
                             >
                                Akad Nikah
                            </p>
                              <p class="text-center font-semibold  text-xl wow" style="font-family: 'Urbanist', sans-serif;"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"                      
                              >
                                {{format($store.state.data.undangan.tanggal_akad)}}
                            </p>
                            <p class="text-center font-semibold text-lg wow"
                        :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                            >
                                {{$store.state.data.undangan.jam_akad}}
                            </p>
                            <p class="text-center font-semibold text-sm wow"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                            >
                                Lokasi Acara
                            </p>
                            <p class="text-center wow"
                            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                             v-html="$store.state.data.undangan.alamat_akad">
                            </p>
                            <hr class="style17" style="">
                            </div>
                        </div>
                    </div> -->
                    <!--  -->
                    <div class="row justify-content-center" v-for="(item, index) in $store.state.data.acara" :key="index+'acara'">
                        <div class="col-10 text-center" style="line-heigth:0.5;">
                           <curve-text :width="250" :height="80" :r="60" offset="50%" textid="my-curve-text" 
                            style="margin-bottom:-40px;font-size:21px;letter-spacing:2px;font-family: 'Kaisei HarunoUmi', serif;display:block;margin:auto;"
                            class="font-semibold text-center"
                            >SAVE THE DATE</curve-text>
                            <div class="" style="position:relative;margin-top:-35px;width:100%;">
                             <p class=" text-4xl  text-center wow" style="letter-spacing: 2px;word-spacing: 2px;font-family: 'Alex Brush', cursive;"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                             >
                                {{item.judul_acara}}
                            </p>
                              <p class="text-center font-semibold text-xl wow" style="font-family: 'Urbanist', sans-serif;"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                              >
                                {{format(item.tanggal_acara)}}
                            </p>
                            <p class="text-center font-semibold text-lg wow"
                            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                            >
                                {{item.jam_acara}}
                            </p>
                            <p class="text-center font-semibold text-sm wow"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                            >
                                Lokasi Acara
                            </p>
                            <p class="text-center wow"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                             v-html="item.alamat_acara">
                            </p>
                            <hr class="style17" style="">
                            </div>
                        </div>
                    </div>
                    <!--  -->
                  </div>
              </div>
            <br>
            <br>
            <br>
            <br> <br>
            <br>
          </div>
        </div>
    </div>
</template>
<script>
import 'particles.js'
var id = require("date-fns/locale/id");
import CurveText from '@inotom/vue-curve-text';
export default{
 components: {
        CurveText,
    },
  props:['particle'],
    mounted() {
        window.particlesJS("particlesjs3", this.$store.state.particle)
    },
    methods: {
         format(tgl) {
            return this.$datefns.format(
                new Date(tgl),
                "dddd, DD MMMM YYYY",
                 {
                  locale: id,
                }
            )
        },
    },
}
</script>